module.exports = __webpack_public_path__ + "media/src/TimeSale/images/present-88250bd3b3624d09b305d1df827b6931.svg";